import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { Fragment, useState } from "react";
import { ProfileForm } from "../../components/pages/user/profile/ProfileForm";
import { useUser } from "../../hooks/react-query/useUser";
import { Container } from "../../components/UI/container/Container";
import dynamic from "next/dynamic";
import { Footer } from "../../components/pages/homepage/footer/Footer";

// @ts-ignore
export async function getStaticProps({ locale }) {
  return {
    props: {
      ...(await serverSideTranslations(locale, ["common"])),
      // Will be passed to the page component as props
    },
  };
}

const UserHeader = dynamic(
  () =>
    import("./../../components/pages/user/page/UserHeader").then(
      (mod) => mod.UserHeader
    ),
  {
    ssr: false,
  }
);

export default function SettingsPage() {
  const [openProfileForm, setOpenProfileForm] = useState<boolean>(true);
  const { user } = useUser();

  function closeForm() {
    setOpenProfileForm(false);
    setTimeout(() => {
      setOpenProfileForm(true);
    }, 50);
  }
  return (
    <Fragment>
      {user && (
        <Fragment>
          <UserHeader />
          <Container noHeight>
            <div className="h-full w-full flex justify-center items-center">
              <ProfileForm open={openProfileForm} closeModal={closeForm} />
            </div>
          </Container>
        </Fragment>
      )}
      <Footer isVisible />
    </Fragment>
  );
}
